import type { ReactNode } from "react";

import { TopNav } from "./TopNav";

/**
 * Wrapper that prefixes any authenticated workspace route with the
 * sticky top nav (logo + user menu). Pages still own their own
 * AppShell width container — this only contributes the persistent
 * top chrome described in ``docs/ui-architecture.md`` §1.
 */
export function AuthenticatedShell({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="authenticated-shell"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#fafafa",
      }}
    >
      <TopNav />
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
}
